import(/* webpackMode: "eager", webpackExports: ["SearchPage"] */ "/hisea-ssr/src/components/SearchPage/index.tsx");
